module.exports = __webpack_public_path__ + "img/calendar.c510c5d6.svg";